import {
  Button,
  Card,
  Modal,
  Space,
  Table,
  message,
  Input,
  Typography,
  DatePicker,
  Form,
} from "antd";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { postReq } from "../api";
import useUserDetails from "../utils/useUserDetails";
import moment from "moment";
import { toastNotification } from "../utils/toasthelper";
const { Title } = Typography;
const { TextArea } = Input;
const TimeSheet = () => {
  const userData = useUserDetails();
  const userRole = localStorage.getItem("userRole");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedTasks, setSelectedTasks] = useState([]);
  const [isRejectModalVisible, setIsRejectModalVisible] = useState(false);
  const [issueText, setIssueText] = useState("");
  const [date, setDate] = useState(moment());
  const [tableParams, setTableParams] = useState({
    page: 1,
    limit: 10,
    search: date,
  });
  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date) => formatDate(date),
    },
    {
      title: "Candidate Name",
      dataIndex: ["userId", "name"],
      key: "candidatename",
    },
    {
      title: "Project Name",
      dataIndex: "projectName",
      key: "projectName",
    },
    {
      title: "Working Hours",
      dataIndex: "TotalWorkingHours",
      key: "TotalWorkingHours",
      render: (hour) => hour.toFixed(2),
    },
    {
      title: "Status",
      key: "approvalStatus",
      render: (_, record) =>
        record.approvalStatus === "pending" ? (
          <svg
            width="70"
            height="28"
            viewBox="0 0 70 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="70" height="28" rx="12" fill="#E5E5E5" />
            <path
              d="M16.732 12.144C16.732 12.568 16.632 12.968 16.432 13.344C16.232 13.72 15.912 14.028 15.472 14.268C15.032 14.5 14.468 14.616 13.78 14.616H12.268V18H10.9V9.66H13.78C14.42 9.66 14.96 9.772 15.4 9.996C15.848 10.212 16.18 10.508 16.396 10.884C16.62 11.26 16.732 11.68 16.732 12.144ZM13.78 13.5C14.3 13.5 14.688 13.384 14.944 13.152C15.2 12.912 15.328 12.576 15.328 12.144C15.328 11.232 14.812 10.776 13.78 10.776H12.268V13.5H13.78ZM24.0967 14.532C24.0967 14.78 24.0807 15.004 24.0487 15.204H18.9967C19.0367 15.732 19.2327 16.156 19.5847 16.476C19.9367 16.796 20.3687 16.956 20.8807 16.956C21.6167 16.956 22.1367 16.648 22.4407 16.032H23.9167C23.7167 16.64 23.3527 17.14 22.8247 17.532C22.3047 17.916 21.6567 18.108 20.8807 18.108C20.2487 18.108 19.6807 17.968 19.1767 17.688C18.6807 17.4 18.2887 17 18.0007 16.488C17.7207 15.968 17.5807 15.368 17.5807 14.688C17.5807 14.008 17.7167 13.412 17.9887 12.9C18.2687 12.38 18.6567 11.98 19.1527 11.7C19.6567 11.42 20.2327 11.28 20.8807 11.28C21.5047 11.28 22.0607 11.416 22.5487 11.688C23.0367 11.96 23.4167 12.344 23.6887 12.84C23.9607 13.328 24.0967 13.892 24.0967 14.532ZM22.6687 14.1C22.6607 13.596 22.4807 13.192 22.1287 12.888C21.7767 12.584 21.3407 12.432 20.8207 12.432C20.3487 12.432 19.9447 12.584 19.6087 12.888C19.2727 13.184 19.0727 13.588 19.0087 14.1H22.6687ZM28.779 11.28C29.299 11.28 29.763 11.388 30.171 11.604C30.587 11.82 30.911 12.14 31.143 12.564C31.375 12.988 31.491 13.5 31.491 14.1V18H30.135V14.304C30.135 13.712 29.987 13.26 29.691 12.948C29.395 12.628 28.991 12.468 28.479 12.468C27.967 12.468 27.559 12.628 27.255 12.948C26.959 13.26 26.811 13.712 26.811 14.304V18H25.443V11.388H26.811V12.144C27.035 11.872 27.319 11.66 27.663 11.508C28.015 11.356 28.387 11.28 28.779 11.28ZM32.7799 14.664C32.7799 14 32.9159 13.412 33.1879 12.9C33.4679 12.388 33.8439 11.992 34.3159 11.712C34.7959 11.424 35.3279 11.28 35.9119 11.28C36.3439 11.28 36.7679 11.376 37.1839 11.568C37.6079 11.752 37.9439 12 38.1919 12.312V9.12H39.5719V18H38.1919V17.004C37.9679 17.324 37.6559 17.588 37.2559 17.796C36.8639 18.004 36.4119 18.108 35.8999 18.108C35.3239 18.108 34.7959 17.964 34.3159 17.676C33.8439 17.38 33.4679 16.972 33.1879 16.452C32.9159 15.924 32.7799 15.328 32.7799 14.664ZM38.1919 14.688C38.1919 14.232 38.0959 13.836 37.9039 13.5C37.7199 13.164 37.4759 12.908 37.1719 12.732C36.8679 12.556 36.5399 12.468 36.1879 12.468C35.8359 12.468 35.5079 12.556 35.2039 12.732C34.8999 12.9 34.6519 13.152 34.4599 13.488C34.2759 13.816 34.1839 14.208 34.1839 14.664C34.1839 15.12 34.2759 15.52 34.4599 15.864C34.6519 16.208 34.8999 16.472 35.2039 16.656C35.5159 16.832 35.8439 16.92 36.1879 16.92C36.5399 16.92 36.8679 16.832 37.1719 16.656C37.4759 16.48 37.7199 16.224 37.9039 15.888C38.0959 15.544 38.1919 15.144 38.1919 14.688ZM42.0648 10.512C41.8168 10.512 41.6088 10.428 41.4408 10.26C41.2728 10.092 41.1888 9.884 41.1888 9.636C41.1888 9.388 41.2728 9.18 41.4408 9.012C41.6088 8.844 41.8168 8.76 42.0648 8.76C42.3048 8.76 42.5088 8.844 42.6768 9.012C42.8448 9.18 42.9288 9.388 42.9288 9.636C42.9288 9.884 42.8448 10.092 42.6768 10.26C42.5088 10.428 42.3048 10.512 42.0648 10.512ZM42.7368 11.388V18H41.3688V11.388H42.7368ZM47.8688 11.28C48.3888 11.28 48.8528 11.388 49.2608 11.604C49.6768 11.82 50.0008 12.14 50.2328 12.564C50.4648 12.988 50.5808 13.5 50.5808 14.1V18H49.2248V14.304C49.2248 13.712 49.0768 13.26 48.7808 12.948C48.4848 12.628 48.0808 12.468 47.5688 12.468C47.0568 12.468 46.6488 12.628 46.3448 12.948C46.0488 13.26 45.9008 13.712 45.9008 14.304V18H44.5328V11.388H45.9008V12.144C46.1248 11.872 46.4088 11.66 46.7528 11.508C47.1048 11.356 47.4768 11.28 47.8688 11.28ZM54.9898 11.28C55.5018 11.28 55.9538 11.384 56.3458 11.592C56.7458 11.792 57.0578 12.044 57.2818 12.348V11.388H58.6618V18.108C58.6618 18.716 58.5338 19.256 58.2778 19.728C58.0218 20.208 57.6498 20.584 57.1618 20.856C56.6818 21.128 56.1058 21.264 55.4338 21.264C54.5378 21.264 53.7938 21.052 53.2018 20.628C52.6098 20.212 52.2738 19.644 52.1938 18.924H53.5498C53.6538 19.268 53.8738 19.544 54.2098 19.752C54.5538 19.968 54.9618 20.076 55.4338 20.076C55.9858 20.076 56.4298 19.908 56.7658 19.572C57.1098 19.236 57.2818 18.748 57.2818 18.108V17.004C57.0498 17.316 56.7338 17.58 56.3338 17.796C55.9418 18.004 55.4938 18.108 54.9898 18.108C54.4138 18.108 53.8858 17.964 53.4058 17.676C52.9338 17.38 52.5578 16.972 52.2778 16.452C52.0058 15.924 51.8698 15.328 51.8698 14.664C51.8698 14 52.0058 13.412 52.2778 12.9C52.5578 12.388 52.9338 11.992 53.4058 11.712C53.8858 11.424 54.4138 11.28 54.9898 11.28ZM57.2818 14.688C57.2818 14.232 57.1858 13.836 56.9938 13.5C56.8098 13.164 56.5658 12.908 56.2618 12.732C55.9578 12.556 55.6298 12.468 55.2778 12.468C54.9258 12.468 54.5978 12.556 54.2938 12.732C53.9898 12.9 53.7418 13.152 53.5498 13.488C53.3658 13.816 53.2738 14.208 53.2738 14.664C53.2738 15.12 53.3658 15.52 53.5498 15.864C53.7418 16.208 53.9898 16.472 54.2938 16.656C54.6058 16.832 54.9338 16.92 55.2778 16.92C55.6298 16.92 55.9578 16.832 56.2618 16.656C56.5658 16.48 56.8098 16.224 56.9938 15.888C57.1858 15.544 57.2818 15.144 57.2818 14.688Z"
              fill="#666666"
            />
          </svg>
        ) : record.approvalStatus === "rejected" ? (
          <svg
            width="93"
            height="28"
            viewBox="0 0 93 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="93" height="28" rx="12" fill="#FEECEB" />
            <path
              d="M16.0872 7.73177C16.6206 7.30414 17.3794 7.30414 17.9128 7.73177C18.2476 8.00016 18.6836 8.10761 19.1047 8.02555C19.7758 7.8948 20.4477 8.24743 20.7213 8.87396C20.893 9.2672 21.229 9.56494 21.6401 9.688C22.2951 9.88408 22.7261 10.5086 22.6772 11.1905C22.6465 11.6185 22.8057 12.0383 23.1125 12.3383C23.6013 12.8163 23.6928 13.5695 23.3326 14.1506C23.1065 14.5153 23.0524 14.961 23.1846 15.3692C23.3953 16.0196 23.1262 16.7291 22.5372 17.0762C22.1675 17.2941 21.9125 17.6636 21.8399 18.0865C21.7242 18.7603 21.1562 19.2635 20.4734 19.2972C20.0448 19.3183 19.6472 19.5269 19.3864 19.8676C18.9708 20.4105 18.2341 20.5921 17.6138 20.3045C17.2245 20.1241 16.7755 20.1241 16.3862 20.3045C15.7659 20.5921 15.0292 20.4105 14.6136 19.8676C14.3528 19.5269 13.9552 19.3183 13.5266 19.2972C12.8438 19.2635 12.2758 18.7603 12.1601 18.0865C12.0875 17.6636 11.8325 17.2941 11.4628 17.0762C10.8738 16.7291 10.6047 16.0196 10.8154 15.3692C10.9476 14.961 10.8935 14.5153 10.6674 14.1506C10.3072 13.5695 10.3987 12.8163 10.8875 12.3383C11.1943 12.0383 11.3535 11.6185 11.3228 11.1905C11.2739 10.5086 11.7049 9.88408 12.3599 9.688C12.771 9.56494 13.107 9.2672 13.2787 8.87396C13.5523 8.24743 14.2242 7.8948 14.8953 8.02555C15.3164 8.10761 15.7524 8.00016 16.0872 7.73177Z"
              fill="#F44336"
            />
            <path
              d="M19 12L15 16"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
            />
            <path
              d="M19 16L15 12"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
            />
            <path
              d="M35.232 18L33.312 14.664H32.268V18H30.9V9.66H33.78C34.42 9.66 34.96 9.772 35.4 9.996C35.848 10.22 36.18 10.52 36.396 10.896C36.62 11.272 36.732 11.692 36.732 12.156C36.732 12.7 36.572 13.196 36.252 13.644C35.94 14.084 35.456 14.384 34.8 14.544L36.864 18H35.232ZM32.268 13.572H33.78C34.292 13.572 34.676 13.444 34.932 13.188C35.196 12.932 35.328 12.588 35.328 12.156C35.328 11.724 35.2 11.388 34.944 11.148C34.688 10.9 34.3 10.776 33.78 10.776H32.268V13.572ZM44.542 14.532C44.542 14.78 44.526 15.004 44.494 15.204H39.442C39.482 15.732 39.678 16.156 40.03 16.476C40.382 16.796 40.814 16.956 41.326 16.956C42.062 16.956 42.582 16.648 42.886 16.032H44.362C44.162 16.64 43.798 17.14 43.27 17.532C42.75 17.916 42.102 18.108 41.326 18.108C40.694 18.108 40.126 17.968 39.622 17.688C39.126 17.4 38.734 17 38.446 16.488C38.166 15.968 38.026 15.368 38.026 14.688C38.026 14.008 38.162 13.412 38.434 12.9C38.714 12.38 39.102 11.98 39.598 11.7C40.102 11.42 40.678 11.28 41.326 11.28C41.95 11.28 42.506 11.416 42.994 11.688C43.482 11.96 43.862 12.344 44.134 12.84C44.406 13.328 44.542 13.892 44.542 14.532ZM43.114 14.1C43.106 13.596 42.926 13.192 42.574 12.888C42.222 12.584 41.786 12.432 41.266 12.432C40.794 12.432 40.39 12.584 40.054 12.888C39.718 13.184 39.518 13.588 39.454 14.1H43.114ZM46.5843 10.512C46.3363 10.512 46.1283 10.428 45.9603 10.26C45.7923 10.092 45.7083 9.884 45.7083 9.636C45.7083 9.388 45.7923 9.18 45.9603 9.012C46.1283 8.844 46.3363 8.76 46.5843 8.76C46.8243 8.76 47.0283 8.844 47.1963 9.012C47.3643 9.18 47.4483 9.388 47.4483 9.636C47.4483 9.884 47.3643 10.092 47.1963 10.26C47.0283 10.428 46.8243 10.512 46.5843 10.512ZM47.2563 19.296C47.2563 19.944 47.0923 20.412 46.7643 20.7C46.4443 20.996 45.9763 21.144 45.3603 21.144H44.6523V19.992H45.1203C45.4003 19.992 45.5963 19.936 45.7083 19.824C45.8283 19.72 45.8883 19.544 45.8883 19.296V11.388H47.2563V19.296ZM55.1123 14.532C55.1123 14.78 55.0963 15.004 55.0643 15.204H50.0123C50.0523 15.732 50.2483 16.156 50.6003 16.476C50.9523 16.796 51.3843 16.956 51.8963 16.956C52.6323 16.956 53.1523 16.648 53.4563 16.032H54.9323C54.7323 16.64 54.3683 17.14 53.8403 17.532C53.3203 17.916 52.6723 18.108 51.8963 18.108C51.2643 18.108 50.6963 17.968 50.1923 17.688C49.6963 17.4 49.3043 17 49.0163 16.488C48.7363 15.968 48.5963 15.368 48.5963 14.688C48.5963 14.008 48.7323 13.412 49.0043 12.9C49.2843 12.38 49.6723 11.98 50.1683 11.7C50.6723 11.42 51.2483 11.28 51.8963 11.28C52.5203 11.28 53.0763 11.416 53.5643 11.688C54.0523 11.96 54.4323 12.344 54.7043 12.84C54.9763 13.328 55.1123 13.892 55.1123 14.532ZM53.6843 14.1C53.6763 13.596 53.4963 13.192 53.1443 12.888C52.7923 12.584 52.3563 12.432 51.8363 12.432C51.3643 12.432 50.9603 12.584 50.6243 12.888C50.2883 13.184 50.0883 13.588 50.0243 14.1H53.6843ZM56.0026 14.688C56.0026 14.008 56.1386 13.412 56.4106 12.9C56.6906 12.38 57.0746 11.98 57.5626 11.7C58.0506 11.42 58.6106 11.28 59.2426 11.28C60.0426 11.28 60.7026 11.472 61.2226 11.856C61.7506 12.232 62.1066 12.772 62.2906 13.476H60.8146C60.6946 13.148 60.5026 12.892 60.2386 12.708C59.9746 12.524 59.6426 12.432 59.2426 12.432C58.6826 12.432 58.2346 12.632 57.8986 13.032C57.5706 13.424 57.4066 13.976 57.4066 14.688C57.4066 15.4 57.5706 15.956 57.8986 16.356C58.2346 16.756 58.6826 16.956 59.2426 16.956C60.0346 16.956 60.5586 16.608 60.8146 15.912H62.2906C62.0986 16.584 61.7386 17.12 61.2106 17.52C60.6826 17.912 60.0266 18.108 59.2426 18.108C58.6106 18.108 58.0506 17.968 57.5626 17.688C57.0746 17.4 56.6906 17 56.4106 16.488C56.1386 15.968 56.0026 15.368 56.0026 14.688ZM65.2499 12.504V16.164C65.2499 16.412 65.3059 16.592 65.4179 16.704C65.5379 16.808 65.7379 16.86 66.0179 16.86H66.8579V18H65.7779C65.1619 18 64.6899 17.856 64.3619 17.568C64.0339 17.28 63.8699 16.812 63.8699 16.164V12.504H63.0899V11.388H63.8699V9.744H65.2499V11.388H66.8579V12.504H65.2499ZM74.1788 14.532C74.1788 14.78 74.1628 15.004 74.1308 15.204H69.0788C69.1188 15.732 69.3148 16.156 69.6668 16.476C70.0188 16.796 70.4508 16.956 70.9628 16.956C71.6988 16.956 72.2188 16.648 72.5228 16.032H73.9987C73.7988 16.64 73.4348 17.14 72.9068 17.532C72.3868 17.916 71.7388 18.108 70.9628 18.108C70.3308 18.108 69.7628 17.968 69.2588 17.688C68.7628 17.4 68.3708 17 68.0828 16.488C67.8028 15.968 67.6628 15.368 67.6628 14.688C67.6628 14.008 67.7988 13.412 68.0708 12.9C68.3508 12.38 68.7388 11.98 69.2348 11.7C69.7388 11.42 70.3148 11.28 70.9628 11.28C71.5868 11.28 72.1428 11.416 72.6308 11.688C73.1188 11.96 73.4988 12.344 73.7708 12.84C74.0428 13.328 74.1788 13.892 74.1788 14.532ZM72.7508 14.1C72.7428 13.596 72.5628 13.192 72.2108 12.888C71.8588 12.584 71.4228 12.432 70.9028 12.432C70.4308 12.432 70.0268 12.584 69.6908 12.888C69.3548 13.184 69.1548 13.588 69.0908 14.1H72.7508ZM75.069 14.664C75.069 14 75.205 13.412 75.477 12.9C75.757 12.388 76.133 11.992 76.605 11.712C77.085 11.424 77.617 11.28 78.201 11.28C78.633 11.28 79.057 11.376 79.473 11.568C79.897 11.752 80.233 12 80.481 12.312V9.12H81.861V18H80.481V17.004C80.257 17.324 79.945 17.588 79.545 17.796C79.153 18.004 78.701 18.108 78.189 18.108C77.613 18.108 77.085 17.964 76.605 17.676C76.133 17.38 75.757 16.972 75.477 16.452C75.205 15.924 75.069 15.328 75.069 14.664ZM80.481 14.688C80.481 14.232 80.385 13.836 80.193 13.5C80.009 13.164 79.765 12.908 79.461 12.732C79.157 12.556 78.829 12.468 78.477 12.468C78.125 12.468 77.797 12.556 77.493 12.732C77.189 12.9 76.941 13.152 76.749 13.488C76.565 13.816 76.473 14.208 76.473 14.664C76.473 15.12 76.565 15.52 76.749 15.864C76.941 16.208 77.189 16.472 77.493 16.656C77.805 16.832 78.133 16.92 78.477 16.92C78.829 16.92 79.157 16.832 79.461 16.656C79.765 16.48 80.009 16.224 80.193 15.888C80.385 15.544 80.481 15.144 80.481 14.688Z"
              fill="#F44336"
            />
          </svg>
        ) : record.approvalStatus === "approved" ? (
          <svg
            width="90"
            height="24"
            viewBox="0 0 100 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="100" height="28" rx="12" fill="#E3EDE4" />
            <path
              d="M16.0872 7.73177C16.6206 7.30414 17.3794 7.30414 17.9128 7.73177C18.2476 8.00016 18.6836 8.10761 19.1047 8.02555C19.7758 7.8948 20.4477 8.24743 20.7213 8.87396C20.893 9.2672 21.229 9.56494 21.6401 9.688C22.2951 9.88408 22.7261 10.5086 22.6772 11.1905C22.6465 11.6185 22.8057 12.0383 23.1125 12.3383C23.6013 12.8163 23.6928 13.5695 23.3326 14.1506C23.1065 14.5153 23.0524 14.961 23.1846 15.3692C23.3953 16.0196 23.1262 16.7291 22.5372 17.0762C22.1675 17.2941 21.9125 17.6636 21.8399 18.0865C21.7242 18.7603 21.1562 19.2635 20.4734 19.2972C20.0448 19.3183 19.6472 19.5269 19.3864 19.8676C18.9708 20.4105 18.2341 20.5921 17.6138 20.3045C17.2245 20.1241 16.7755 20.1241 16.3862 20.3045C15.7659 20.5921 15.0292 20.4105 14.6136 19.8676C14.3528 19.5269 13.9552 19.3183 13.5266 19.2972C12.8438 19.2635 12.2758 18.7603 12.1601 18.0865C12.0875 17.6636 11.8325 17.2941 11.4628 17.0762C10.8738 16.7291 10.6047 16.0196 10.8154 15.3692C10.9476 14.961 10.8935 14.5153 10.6674 14.1506C10.3072 13.5695 10.3987 12.8163 10.8875 12.3383C11.1943 12.0383 11.3535 11.6185 11.3228 11.1905C11.2739 10.5086 11.7049 9.88408 12.3599 9.688C12.771 9.56494 13.107 9.2672 13.2787 8.87396C13.5523 8.24743 14.2242 7.8948 14.8953 8.02555C15.3164 8.10761 15.7524 8.00016 16.0872 7.73177Z"
              fill="#4CAF50"
            />
            <path
              d="M14.667 13.9999L16.2226 15.5554L19.3337 12.4443"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
            />
            <path
              d="M35.928 16.296H32.436L31.836 18H30.408L33.396 9.648H34.98L37.968 18H36.528L35.928 16.296ZM35.544 15.18L34.188 11.304L32.82 15.18H35.544ZM40.6352 12.36C40.8672 12.056 41.1832 11.8 41.5832 11.592C41.9832 11.384 42.4352 11.28 42.9392 11.28C43.5152 11.28 44.0392 11.424 44.5112 11.712C44.9912 11.992 45.3672 12.388 45.6392 12.9C45.9112 13.412 46.0472 14 46.0472 14.664C46.0472 15.328 45.9112 15.924 45.6392 16.452C45.3672 16.972 44.9912 17.38 44.5112 17.676C44.0392 17.964 43.5152 18.108 42.9392 18.108C42.4352 18.108 41.9872 18.008 41.5952 17.808C41.2032 17.6 40.8832 17.344 40.6352 17.04V21.144H39.2672V11.388H40.6352V12.36ZM44.6552 14.664C44.6552 14.208 44.5592 13.816 44.3672 13.488C44.1832 13.152 43.9352 12.9 43.6232 12.732C43.3192 12.556 42.9912 12.468 42.6392 12.468C42.2952 12.468 41.9672 12.556 41.6552 12.732C41.3512 12.908 41.1032 13.164 40.9112 13.5C40.7272 13.836 40.6352 14.232 40.6352 14.688C40.6352 15.144 40.7272 15.544 40.9112 15.888C41.1032 16.224 41.3512 16.48 41.6552 16.656C41.9672 16.832 42.2952 16.92 42.6392 16.92C42.9912 16.92 43.3192 16.832 43.6232 16.656C43.9352 16.472 44.1832 16.208 44.3672 15.864C44.5592 15.52 44.6552 15.12 44.6552 14.664ZM48.768 12.36C49 12.056 49.316 11.8 49.716 11.592C50.116 11.384 50.568 11.28 51.072 11.28C51.648 11.28 52.172 11.424 52.644 11.712C53.124 11.992 53.5 12.388 53.772 12.9C54.044 13.412 54.18 14 54.18 14.664C54.18 15.328 54.044 15.924 53.772 16.452C53.5 16.972 53.124 17.38 52.644 17.676C52.172 17.964 51.648 18.108 51.072 18.108C50.568 18.108 50.12 18.008 49.728 17.808C49.336 17.6 49.016 17.344 48.768 17.04V21.144H47.4V11.388H48.768V12.36ZM52.788 14.664C52.788 14.208 52.692 13.816 52.5 13.488C52.316 13.152 52.068 12.9 51.756 12.732C51.452 12.556 51.124 12.468 50.772 12.468C50.428 12.468 50.1 12.556 49.788 12.732C49.484 12.908 49.236 13.164 49.044 13.5C48.86 13.836 48.768 14.232 48.768 14.688C48.768 15.144 48.86 15.544 49.044 15.888C49.236 16.224 49.484 16.48 49.788 16.656C50.1 16.832 50.428 16.92 50.772 16.92C51.124 16.92 51.452 16.832 51.756 16.656C52.068 16.472 52.316 16.208 52.5 15.864C52.692 15.52 52.788 15.12 52.788 14.664ZM56.9008 12.348C57.1008 12.012 57.3648 11.752 57.6928 11.568C58.0288 11.376 58.4248 11.28 58.8808 11.28V12.696H58.5328C57.9968 12.696 57.5888 12.832 57.3088 13.104C57.0368 13.376 56.9008 13.848 56.9008 14.52V18H55.5328V11.388H56.9008V12.348ZM63.0063 18.108C62.3823 18.108 61.8183 17.968 61.3143 17.688C60.8103 17.4 60.4143 17 60.1263 16.488C59.8383 15.968 59.6943 15.368 59.6943 14.688C59.6943 14.016 59.8423 13.42 60.1383 12.9C60.4343 12.38 60.8383 11.98 61.3503 11.7C61.8623 11.42 62.4343 11.28 63.0663 11.28C63.6983 11.28 64.2703 11.42 64.7823 11.7C65.2943 11.98 65.6983 12.38 65.9943 12.9C66.2903 13.42 66.4383 14.016 66.4383 14.688C66.4383 15.36 66.2863 15.956 65.9823 16.476C65.6783 16.996 65.2623 17.4 64.7343 17.688C64.2143 17.968 63.6383 18.108 63.0063 18.108ZM63.0063 16.92C63.3583 16.92 63.6863 16.836 63.9903 16.668C64.3023 16.5 64.5543 16.248 64.7463 15.912C64.9383 15.576 65.0343 15.168 65.0343 14.688C65.0343 14.208 64.9423 13.804 64.7583 13.476C64.5743 13.14 64.3303 12.888 64.0263 12.72C63.7223 12.552 63.3943 12.468 63.0423 12.468C62.6903 12.468 62.3623 12.552 62.0583 12.72C61.7623 12.888 61.5263 13.14 61.3503 13.476C61.1743 13.804 61.0863 14.208 61.0863 14.688C61.0863 15.4 61.2663 15.952 61.6263 16.344C61.9943 16.728 62.4543 16.92 63.0063 16.92ZM70.3466 16.776L72.2186 11.388H73.6706L71.1506 18H69.5186L67.0106 11.388H68.4746L70.3466 16.776ZM80.7647 14.532C80.7647 14.78 80.7487 15.004 80.7167 15.204H75.6647C75.7047 15.732 75.9007 16.156 76.2527 16.476C76.6047 16.796 77.0367 16.956 77.5487 16.956C78.2847 16.956 78.8047 16.648 79.1087 16.032H80.5847C80.3847 16.64 80.0207 17.14 79.4927 17.532C78.9727 17.916 78.3247 18.108 77.5487 18.108C76.9167 18.108 76.3487 17.968 75.8447 17.688C75.3487 17.4 74.9567 17 74.6687 16.488C74.3887 15.968 74.2487 15.368 74.2487 14.688C74.2487 14.008 74.3847 13.412 74.6567 12.9C74.9367 12.38 75.3247 11.98 75.8207 11.7C76.3247 11.42 76.9007 11.28 77.5487 11.28C78.1727 11.28 78.7287 11.416 79.2167 11.688C79.7047 11.96 80.0847 12.344 80.3567 12.84C80.6287 13.328 80.7647 13.892 80.7647 14.532ZM79.3367 14.1C79.3287 13.596 79.1487 13.192 78.7967 12.888C78.4447 12.584 78.0087 12.432 77.4887 12.432C77.0167 12.432 76.6127 12.584 76.2767 12.888C75.9407 13.184 75.7407 13.588 75.6767 14.1H79.3367ZM81.6549 14.664C81.6549 14 81.7909 13.412 82.0629 12.9C82.3429 12.388 82.7189 11.992 83.1909 11.712C83.6709 11.424 84.2029 11.28 84.7869 11.28C85.2189 11.28 85.6429 11.376 86.0589 11.568C86.4829 11.752 86.8189 12 87.0669 12.312V9.12H88.4469V18H87.0669V17.004C86.8429 17.324 86.5309 17.588 86.1309 17.796C85.7389 18.004 85.2869 18.108 84.7749 18.108C84.1989 18.108 83.6709 17.964 83.1909 17.676C82.7189 17.38 82.3429 16.972 82.0629 16.452C81.7909 15.924 81.6549 15.328 81.6549 14.664ZM87.0669 14.688C87.0669 14.232 86.9709 13.836 86.7789 13.5C86.5949 13.164 86.3509 12.908 86.0469 12.732C85.7429 12.556 85.4149 12.468 85.0629 12.468C84.7109 12.468 84.3829 12.556 84.0789 12.732C83.7749 12.9 83.5269 13.152 83.3349 13.488C83.1509 13.816 83.0589 14.208 83.0589 14.664C83.0589 15.12 83.1509 15.52 83.3349 15.864C83.5269 16.208 83.7749 16.472 84.0789 16.656C84.3909 16.832 84.7189 16.92 85.0629 16.92C85.4149 16.92 85.7429 16.832 86.0469 16.656C86.3509 16.48 86.5949 16.224 86.7789 15.888C86.9709 15.544 87.0669 15.144 87.0669 14.688Z"
              fill="#4CAF50"
            />
          </svg>
        ) : null,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => {
        const isCandidate = userRole === "candidate";
        return (
          <Space size="middle">
            <div style={{ cursor: "pointer" }}>
              {(isCandidate && record.approvalStatus === "rejected") ||
              (isCandidate && record.approvalStatus === "pending") ? (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() =>
                    history.push("/company/edit-TimeSheet", { data: record })
                  }
                >
                  <path
                    d="M16.625 13.608L11.6667 18.5663C11.2315 19.0003 10.6307 19.25 10.017 19.25H9.33333V18.5663C9.33333 17.9433 9.576 17.3577 10.017 16.9167L14.9753 11.9583L16.625 13.608ZM17.8418 9.09183L16.625 10.3087L18.2747 11.9583L19.4915 10.7415C19.9465 10.2865 19.9465 9.54683 19.4915 9.09183C19.0505 8.64967 18.2817 8.64967 17.8418 9.09183ZM28 5.83333V22.1667C28 25.3832 25.3832 28 22.1667 28H5.83333C2.61683 28 0 25.3832 0 22.1667V5.83333C0 2.61683 2.61683 0 5.83333 0H22.1667C25.3832 0 28 2.61683 28 5.83333ZM21.1423 7.44217C19.8193 6.12033 17.514 6.12033 16.1922 7.44217L8.36733 15.267C7.4865 16.1478 7 17.3203 7 18.5663V20.4167C7 21.0618 7.52267 21.5833 8.16667 21.5833H10.017C11.263 21.5833 12.4355 21.098 13.3163 20.216L21.1412 12.3912C22.5062 11.0262 22.5073 8.80717 21.1423 7.44217Z"
                    fill="#666666"
                  />
                </svg>
              ) : isCandidate && record.approvalStatus === "approved" ? (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.625 13.608L11.6667 18.5663C11.2315 19.0003 10.6307 19.25 10.017 19.25H9.33333V18.5663C9.33333 17.9433 9.576 17.3577 10.017 16.9167L14.9753 11.9583L16.625 13.608ZM17.8418 9.09183L16.625 10.3087L18.2747 11.9583L19.4915 10.7415C19.9465 10.2865 19.9465 9.54683 19.4915 9.09183C19.0505 8.64967 18.2817 8.64967 17.8418 9.09183ZM28 5.83333V22.1667C28 25.3832 25.3832 28 22.1667 28H5.83333C2.61683 28 0 25.3832 0 22.1667V5.83333C0 2.61683 2.61683 0 5.83333 0H22.1667C25.3832 0 28 2.61683 28 5.83333ZM21.1423 7.44217C19.8193 6.12033 17.514 6.12033 16.1922 7.44217L8.36733 15.267C7.4865 16.1478 7 17.3203 7 18.5663V20.4167C7 21.0618 7.52267 21.5833 8.16667 21.5833H10.017C11.263 21.5833 12.4355 21.098 13.3163 20.216L21.1412 12.3912C22.5062 11.0262 22.5073 8.80717 21.1423 7.44217Z"
                    fill="#D2D2D2"
                  />
                </svg>
              ) : (
                <svg
                  width="20"
                  height="16"
                  viewBox="0 0 30 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => hadleShowModal(record)}
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M14.2818 0.0159601C7.45391 0.319947 1.70525 4.93397 0.109432 11.136C0.03645 11.4196 0 11.7099 0 12C0 12.2901 0.0364637 12.5804 0.109432 12.864C1.68348 18.9815 7.29798 23.554 14.0032 23.9692C14.3329 23.9896 14.6654 24 15 24C22.14 24 28.2391 19.2824 29.8906 12.864C29.9636 12.5804 30 12.2901 30 12C30 11.7099 29.9636 11.4196 29.8906 11.136C28.2391 4.71767 22.14 0 15 0C14.7593 0 14.5199 0.00536006 14.2818 0.0159601ZM21.8182 12C21.8182 15.6819 18.7657 18.6667 15 18.6667C11.2345 18.6667 8.18186 15.6819 8.18186 12C8.18186 8.31811 11.2345 5.33333 15 5.33333C18.7657 5.33333 21.8182 8.31811 21.8182 12ZM15 16C17.2594 16 19.0909 14.2092 19.0909 12C19.0909 9.7908 17.2594 8 15 8C12.7407 8 10.9091 9.7908 10.9091 12C10.9091 14.2092 12.7407 16 15 16Z"
                    fill="#13487D"
                  />
                </svg>
              )}
            </div>
          </Space>
        );
      },
    },
  ];
  const hadleShowModal = (task) => {
    setShowModal(true);
    setSelectedTasks(task);
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setIsRejectModalVisible(false);
    setSelectedTasks([]);
  };
  const handleRejectClick = () => {
    setIsRejectModalVisible(true);
  };

  const handleSubmitIssue = async () => {
    if (selectedTasks.rejectionMessage.length >= 2) {
      message.error("You can only Reject Timesheet upto three times");
      return;
    }
    if (!issueText.trim()) {
      message.error("Please enter an issue before submitting!");
      return;
    }
    const response = await postReq("/company/update-timesheet-status", {
      _id: selectedTasks._id,
      status: "rejected",
      rejectionMessage: issueText,
    });
    message.success("Issue submitted successfully!", response.message);
    setShowModal(false);
    setIsRejectModalVisible(false);
    setIssueText("");
  };
  const handleSubmitApproval = async () => {
    const response = await postReq("/company/update-timesheet-status", {
      _id: selectedTasks._id,
      status: "approved",
      rejectionMessage: "",
    });
    if (response.status == 1) {
      toastNotification("success", response.message);
      setShowModal(false);
      setIsRejectModalVisible(false);
      setIssueText("");
      setLoading(false);
      await fetchData();
      // history.push("/company/TimeSheet");
    } else {
      setLoading(false);
      setShowModal(false);
      setIsRejectModalVisible(false);
      setIssueText("");
    }
    // message.success("Issue submitted successfully!", response.message);
    // setShowModal(false);
    // setIsRejectModalVisible(false);
    // setIssueText("");
  };

  const handleCloseRejectModal = () => {
    setIsRejectModalVisible(false);
    setIssueText("");
  };
  const subColumns = [
    {
      title: "Task Name",
      dataIndex: "taskName",
      key: "taskName",
    },
    {
      title: "Task Description",
      dataIndex: "taskDesc",
      key: "taskDesc",
      width: 300,
      render: (text) => (
        <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
          {text}
        </div>
      ),
    },
    {
      title: "Start Time",
      dataIndex: "startTime",
      key: "startTime",
      render: (text) => new Date(text).toLocaleString(), // Format date
    },
    {
      title: "End Time",
      dataIndex: "endTime",
      key: "endTime",
      render: (text) => new Date(text).toLocaleString(), // Format date
    },
  ];
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = String(date.getFullYear()).slice(2); // Take last two digits
    return `${day}/${month}/${year}`;
  };

  const history = useHistory();

  const fetchData = async () => {
    setLoading(true);
    if (!userData || !userData.userRole) {
      setLoading(false);
      return;
    }
    const url =
      userData.userRole === "candidate"
        ? "/company/timesheets"
        : userData.userRole === "vendor"
        ? "/vendor/timesheet-vendor"
        : userData.userRole === "company"
        ? "/company/get-company-timesheet-listing"
        : "/company/get-timesheet-listing";
    try {
      const results = await postReq(url, tableParams);
      if (results.status === 1) {
        const { data } = results;
        const timesheetData =
          userData.userRole !== "candidate" && userData.userRole !== "vendor"
            ? data
            : userData.userRole === "vendor"
            ? data
            : data.timesheet;
        setData(timesheetData);

        setTableParams((prevParams) => ({
          ...prevParams,
          pagination: {
            total: data.totalCount,
          },
        }));
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleMonthSearch = (selectedDate) => {
    if (selectedDate) {
      const firstDayOfMonth = selectedDate.startOf("month").toISOString();
      setDate(firstDayOfMonth);
      setTableParams((prevParams) => ({
        ...prevParams,
        page: 1,
        limit: 10,
        search: firstDayOfMonth, // Make sure `date` is in the correct format
      }));
    }
  };

  useEffect(() => {
    fetchData();
  }, [userData.userRole, date]);
  console.log(selectedTasks);
  return (
    <>
      <Modal
        title={<div style={{ fontWeight: 800 }}>Task</div>}
        open={showModal}
        onCancel={handleCloseModal}
        width={950}
        bodyStyle={{ maxHeight: "500px", overflowY: "auto" }}
        footer={
          userRole === "vendor" || userRole === "company"
            ? null
            : selectedTasks.approvalStatus == "approved"
            ? null
            : [
                <Button key="reject" danger onClick={handleRejectClick}>
                  Reject
                </Button>,
                <Button
                  key="approve"
                  type="primary"
                  onClick={() => handleSubmitApproval()}
                >
                  Approve
                </Button>,
              ]
        }
      >
        <Table
          dataSource={selectedTasks.tasks}
          columns={subColumns}
          rowKey="_id"
          pagination={false}
          scroll={{ x: 850 }}
        />
        {selectedTasks?.rejectionMessage?.length > 0 &&
          selectedTasks?.rejectionMessage.map((data, i) => (
            <Form.Item
              label={`Rejection Messages ${i + 1}`}
              style={{ marginTop: "10px" }}
              required
              disabled
            >
              <p style={{ marginBottom: "0px" }}>{data}</p>
              {/* <Input.TextArea value={data} /> */}
            </Form.Item>
          ))}
      </Modal>

      <Modal
        title="Rejection Reason"
        open={isRejectModalVisible}
        onCancel={handleCloseRejectModal}
        footer={[
          <Button key="cancel" onClick={handleCloseRejectModal}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleSubmitIssue}>
            Submit
          </Button>,
        ]}
      >
        <TextArea
          rows={4}
          placeholder="Please enter the issue for rejection..."
          value={issueText}
          onChange={(e) => setIssueText(e.target.value)}
        />
      </Modal>
      <Card
        title=<div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px",
            borderRadius: "20px 20px 0px 0px",
            margin: "0px , -24px",
            justifyContent: "space-between",
          }}
        >
          <div>
            <Title
              level={4}
              style={{
                marginBottom: 0,
                fontSize: "20px",
                fontWeight: "800",
                color: "#13487D",
              }}
            >
              TimeSheet
            </Title>
          </div>
          {userData?.userRole !== "candidate" ? (
            <DatePicker
              picker="month"
              defaultValue={date}
              onChange={handleMonthSearch}
              placeholder="Select Month"
              style={{ width: 200 }}
            />
          ) : (
            <div style={{ display: "flex", gap: "8px" }}>
              <DatePicker
                picker="month"
                defaultValue={date}
                onChange={handleMonthSearch}
                placeholder="Select Month"
                style={{ width: 200 }}
              />
              <div
                style={{
                  // width: 44,
                  // height: 44,
                  backgroundColor: "#F4F4F4",
                  borderRadius: "18px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
                onClick={() => {
                  history.push("/company/add-TimeSheet");
                }}
              >
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="64" height="64" rx="18" fill="#F4F4F4" />
                  <path
                    d="M32 22V42"
                    stroke="#13487D"
                    strokeWidth="2.7"
                    strokeLinecap="round"
                  />
                  <path
                    d="M42 32L22 32"
                    stroke="#13487D"
                    strokeWidth="2.7"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
            </div>
          )}
          {/* <svg
            width="44"
            height="44"
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ cursor: "pointer" }}
            onClick={() => {
              history.push("/company/add-TimeSheet");
            }}
          >
            <rect width="64" height="64" rx="18" fill="#F4F4F4" />
            <path
              d="M32 22V42"
              stroke="#13487D"
              stroke-width="2.7"
              stroke-linecap="round"
            />
            <path
              d="M42 32L22 32"
              stroke="#13487D"
              stroke-width="2.7"
              stroke-linecap="round"
            />
          </svg> */}
        </div>
        bordered={false}
        style={{ borderRadius: "18px" }}
      >
        <Table
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={false}
        />
      </Card>
    </>
  );
};

export default TimeSheet;
